import PropTypes from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';
import { CheckoutTypes } from '../../../utils/constants';

const prefix = 'CHECKOUT';
const createAction = createPrefixedActionFactory(prefix);

export const removePayment = createAction({
  type: 'REMOVE_PAYMENT',
  propTypes: {
    paymentIndex: PropTypes.number,
    payment: PropTypes.object,
  },
});

export const addPayment = createAction({
  type: 'ADD_PAYMENT',
  propTypes: {
    paymentValue: PropTypes.object,
  },
});

export const addCashierPayment = createAction({
  type: 'ADD_CASHIER_PAYMENT',
  propTypes: {
    paymentMethod: PropTypes.string,
  },
});

export const selectPaymentType = createAction({
  type: 'SELECT_PAYMENT_TYPE',
  propTypes: {
    paymentType: PropTypes.string,
  },
});

export const updatePayment = createAction({
  type: 'UPDATE_PAYMENT',
  propTypes: {
    paymentValue: PropTypes.object,
    paymentIndex: PropTypes.number,
  },
});

export const setPayments = createAction({
  type: 'SET_PAYMENTS',
  propTypes: {
    paymentsValue: PropTypes.array,
  },
});

export const backToOrder = createAction({
  type: 'BACK_TO_ORDER',
  propTypes: {},
});

export const placeOrder = createAction({
  type: 'PLACE_ORDER',
  propTypes: {},
});

export const placeOrderResult = createAction({
  type: 'PLACE_ORDER_RESULT',
  propTypes: {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    orderInfo: PropTypes.object,
  },
});

export const resetOrderResult = createAction({
  type: 'RESET_ORDER_RESULT',
  propTypes: {},
});

export const setCheckoutType = createAction({
  type: 'SET_CHECKOUT_TYPE',
  propTypes: {
    checkoutType: PropTypes.oneOf([CheckoutTypes.MANUALLY, CheckoutTypes.PAY_PER_DISH]),
  },
});

export const orderConfirmed = createAction({
  type: 'ORDER_CONFIRMED',
  propTypes: {
    commentStr: PropTypes.string,
  },
});

export const indicateWaitingForResponseFromServer = createAction({
  type: 'INDICATE_WAITING_FOR_RESPONSE_FROM_SERVER',
  propTypes: {
    isWaitingForResponseFromServer: PropTypes.bool,
  },
});

export const selectSinglePaymentMethod = createAction({
  type: 'SELECT_SINGLE_PAYMENT_METHOD',
  propTypes: {
    singlePaymentMethod: PropTypes.string,
  },
});

export const clearSinglePaymentMethod = createAction({
  type: 'CLEAR_SINGLE_PAYMENT_METHOD',
  propTypes: {},
});

export const setCashierInitializing = createAction({
  type: 'SET_CASHIER_INITIALIZING',
  propTypes: {
    isCashierInitializing: PropTypes.bool,
  },
});

export const setPendingPayment = createAction({
  type: 'SET_PENDING_PAYMENT',
  propTypes: {
    hasPendingPayment: PropTypes.bool,
  },
});
